<script setup lang="ts">
import AirunParticlesBackground from './AirunParticlesBackground.vue'
import AirunLogoLink from './AirunLogoLink.vue'

interface Props {
  title?: string
  description?: string
}

withDefaults(defineProps<Props>(), {
  title: '',
  description: ''
})
</script>

<template>
  <!-- Carries the AIRUN look of the TTS button (dark gradient, drifting dots)
       instead of the yellow warning styling shared by the other disclaimers:
       this one credits a partner service rather than warning the reader. -->
  <div
    class="relative overflow-hidden rounded-[18px] px-4 py-4 shadow-sm"
    style="
      background: linear-gradient(180deg, #0a0e27 0%, #0d1230 100%);
      box-shadow: 0 16px 40px rgba(31, 79, 255, 0.18);
    "
  >
    <AirunParticlesBackground />

    <div class="relative flex items-start gap-3">
      <!-- Larger than in the TTS button: this block is text-led, and the mark
           at button size read as an afterthought next to two lines of copy. -->
      <AirunLogoLink location="news_disclaimer" size-class="h-[68px] w-[68px]" />

      <div class="min-w-0">
        <p class="text-sm font-semibold text-white">
          {{ title }}
        </p>
        <p class="mt-1 text-sm leading-relaxed text-[rgba(219,230,255,0.75)]">
          {{ description }}
        </p>
      </div>
    </div>
  </div>
</template>
